// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /identity/methods-get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeIdentityMethodsGetBody,
  typeIdentityMethodsGetOutput200,
} from "../../sdk/identity/postIdentityMethodsGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildIdentityMethodsGetQueryKey(
  payload: typeIdentityMethodsGetBody,
): string[] {
  const queryKeySegments: string[] = [];

  return [
    "post:identity:identityMethodsGet",
    "svc:auth-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeIdentityMethodsGetOutput200,
    unknown,
    typeIdentityMethodsGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useIdentityMethodsGet(
  payload: typeIdentityMethodsGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildIdentityMethodsGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postIdentityMethodsGet(payload),
    ...resolvedOptions,
  });
}
